import { FormControl, Select, MenuItem, InputBase, Snackbar, Alert } from "@mui/material";
import "../../styling/NavBar.css"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import CreateMoat from "./moatList-components/CreateMoat";
import SignMoat from "./moatList-components/SignMoat";
import CopyButtons from "./moatList-components/CopyButtons";
import { setLoadedMoat } from "../../redux/slices/loadedMoat";


//need to add alerts for createmoat issues

export default function MoatList({ privKey, secret }) {
    const moats = useSelector((state)=> state?.moatName.value)
    const [addingMoat, setAddingMoat] = useState(false)
    const [selectedMoat, setSelectedMoat] = useState("")
    const [error, setError] = useState("")
    const [signMoat, setSignMoat] = useState(false)
    const [loader, setLoader] = useState(false)
    const [apiKey, setApiKey] = useState("")
    const [encryptedSecret, setEncryptedSecret] = useState("")
    const [emptyInput, setEmptyInput] = useState(false)
    const [select, setSelect] = useState(" ")
    const [hovered, setHovered] = useState(false)
    const [success, setSuccess] = useState("")
    
    const [copyStatus, setCopyStatus] = useState(null)

    const dispatch = useDispatch()

    useEffect(() => {
        const data = window.localStorage.getItem('SELECT')
        setSelect(data)
    }, [])

    
    useEffect(() => {
        window.localStorage.setItem('SELECT', select)
    }, [select])

    //need to add functionality to handlechange
    function handleChange(e) {
        if (e.target.value) {
            setSelect(e.target.value)
            setSelectedMoat(moats[e.target.value].moat)
            setApiKey(moats[e.target.value].api_key)
            setEncryptedSecret(moats[e.target.value].secret)
            dispatch(setLoadedMoat(moats[e.target.value].moat))
        }
    }

    
    function closeModal() {
        setAddingMoat(false);
        setLoader(false);
        setEmptyInput(false);
    }

    const MenuProps = {
        PaperProps: {
          style: {
            backgroundColor: "#333333",
          },
        },
      };

    return(
        <>
        <FormControl
            sx={{
                paddingLeft: "7px",
                paddingTop: "1px",
                paddingBottom: "1px",
                //width: "200px",
                height: "30px",
                backgroundColor: "rgba(51, 51, 51, 0.5);3",
                borderRadius: "5px",
                border: "0.5px solid #FCFCFC",
                "& .MuiFilledInput-underline": {
                borderBottom: "0px solid black !important",
                },
                "& .MuiSelect-icon": { color: hovered ? "#118EA0" : "#fff" },
                minWidth: "255px",
                minHeight: "36px",
              }}
        >
            {selectedMoat !== "" ? (
                <Helmet>
                    <title>{selectedMoat} | Home | KwilDB</title>
                    <meta
                    name="description"
                    content="KwilDB is the first decentralized SQL database, enabling complex, highly-scalable, decentralized applications. Manage your KwilDB tables in our DB Visualizer."/>
                </Helmet>
                 ) : (<Helmet>
                         <title>Home | KwilDB</title>
                        <meta
                        name="description"
                    content="KwilDB is the first decentralized SQL database, enabling complex, highly-scalable, decentralized applications. Manage your KwilDB tables in our DB Visualizer."/>
                    </Helmet>)}
            
            <Select
                displayEmpty
                onClose={() => setHovered(false)}
                value={select}
                onChange={handleChange}
                input={<InputBase />}
                MenuProps={MenuProps}
                IconComponent={ExpandMoreIcon}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                sx={{
                    color: hovered ? "#118EA0" : "#fff",
                    fontFamily: "Averta", fontWeight: "700",
                    fontStyle: "normal !important",
                    fontSize: "18px"
                }}
            >
                <MenuItem disabled value="" onMouseEnter={() => setHovered(false)} sx={{ color: "#fff", fontFamily: "Averta" }}>
                    <em>Select Data Set</em>
                </MenuItem>
                {Array.isArray(moats) ? moats.map((item, index) => {
                    return (
                    <MenuItem 
                        key={index}
                        value={index}
                        onClick={() => setSignMoat(true)}
                        sx={{ color: "#fff" }}
                    >
                        {item.moat}
                    </MenuItem>
                    );
                }) : <></>}
    
                <MenuItem
                    onClick={() => setAddingMoat(true)}
                    sx={{ color: "#118EA0" }}
                >
                    Create New Data Set
                    <AddIcon sx={{ height: "20px", marginLeft: "auto" }} />
                </MenuItem>
            </Select>
        </FormControl>
        <CreateMoat 
            setAddingMoat={setAddingMoat}
            addingMoat={addingMoat}
            error={error}
            setError={setError}
            loader={loader}
            setLoader={setLoader}
            emptyInput={emptyInput}
            setEmptyInput={setEmptyInput}
            closeModal={closeModal}
            apiKey={apiKey}
            encryptedSecret={encryptedSecret}
            setSuccess={setSuccess}
        />
        <SignMoat
           signMoat={signMoat}
           setSignMoat={setSignMoat}
           loader={loader}
           setLoader={setLoader}
           moats={moats}
           apiKey={apiKey}
           selectedMoat={selectedMoat}
           error={error}
           setError={setError}
           emptyInput={emptyInput}
           setEmptyInput={setEmptyInput}
           closeModal={closeModal}
           encryptedSecret={encryptedSecret}
        />
        <CopyButtons
            setCopyStatus={setCopyStatus}
            privKey={privKey}
            secret={secret}
        />
        <Snackbar
            sx={{ margin: "0px auto" }}
            open={error}
            autoHideDuration={4000}
            onClose={() => setError("")}
        >
            <Alert
                variant="filled"
                severity="error"
                sx={{ width: "100%" }}
                onClose={() => setError("")}
            >
                {error}
            </Alert>
        </Snackbar>
        <Snackbar
            sx={{ margin: "0px auto" }}
            open={success}
            autoHideDuration={4000}
            onClose={() => setSuccess("")}
        >
            <Alert
                variant="filled"
                severity="success"
                sx={{ width: "100%" }}
                onClose={() => setSuccess("")}
            >
                {success}
            </Alert>
        </Snackbar>
        <Snackbar
            sx={{ margin: "0px auto" }}
            open={copyStatus === "success"}
            autoHideDuration={4000}
            onClose={() => setCopyStatus(null)}
        >
            <Alert
                variant="filled"
                severity="success"
                sx={{ width: "100%" }}
                onClose={() => setCopyStatus(null)}
            >
                Successfully pasted to your clipboard!
            </Alert>
        </Snackbar>
        <Snackbar
            sx={{ margin: "0px auto" }}
            open={copyStatus === "fail"}
            autoHideDuration={4000}
            onClose={() => setCopyStatus(null)}
        >
            <Alert
                variant="filled"
                severity="error"
                sx={{ width: "100%" }}
                onClose={() => setCopyStatus(null)}
            >
                An error occured while pasting to your clipboard!
            </Alert>
        </Snackbar>
        </>
    )
}